<div style="width: 400px" [ngStyle]="data.showFromDate ? {'height.px': 400} : {}">
	<h2 mat-dialog-title>{{ 'CHOOSE_PLANT' | translate }}</h2>
	<mat-dialog-content class="mt-2 mb-4 mat-typography d-flex justify-content-center flex-column">
		<ng-container *ngIf="isLoading; then initialLoading; else loaded"></ng-container>
		<ng-template #initialLoading>
			<mat-spinner [diameter]="30"></mat-spinner>
		</ng-template>

		<ng-template #loaded>

			<div class="row mb-3">
				<label for="plant-id" class="col-sm-4 col-form-label">{{ "PLANT_ID" | translate}}</label>
				<div class="col-sm-8">
					<custom-select [(defaultValue)]="selectedPlant"
								   [values]="plantList"
								   [searchable]="false"
								   [ngStyle]="{'width':'350px'}"
					>
					</custom-select>
				</div>
			</div>

			<div class="row mb-3"  *ngIf="data.showFromDate">
				<label for="plant-id" class="col-sm-4 col-form-label">{{ "FROM_DATE" | translate}}</label>
				<div class="col-sm-8">
					<custom-datepicker [(value)]="fromDate" ></custom-datepicker>
				</div>
			</div>

			<div class="row mb-3" *ngIf="data.showToDate">
				<label for="plant-id" class="col-sm-4 col-form-label">{{ "TO_DATE" | translate}}</label>
				<div class="col-sm-8">
					<custom-datepicker [(value)]="toDate"></custom-datepicker>
				</div>
			</div>

		</ng-template>
	</mat-dialog-content>
	<mat-dialog-actions class="w-100 d-flex justify-content-center">
		<button [mat-dialog-close]="{plantId: null, confirm: false}"
				cdkFocusInitial
				mat-button>{{ 'Cancel' }}
		</button>
		<button [ngStyle]="{'pointer-events': (plantIdMandatory && !selectedPlant) || (data.showFromDate && !fromDate)? 'none' : 'auto'}"
				[mat-dialog-close]="{plantId:selectedPlant, fromDate: fromDate, toDate:toDate,confirm: true}"
				mat-raised-button
				color="primary">
			<label class="text-white">
				{{
					confirmButtonLabel |
						translate
				}}
			</label>
		</button>
	</mat-dialog-actions>
</div>


